export const SplitType = {
  NoSplitting: 0,
  ByPages: 100,
  ByTextPattern: 200,
  BySerialSequence: 300
}
